"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _reportUtil = require("../../utils/reportUtil");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
const _require = require('@tencent/cms-design-component'),
  ScenariosImageText = _require.ScenariosImageText;
const formatAreaCard = (properties, {
  domains
}) => {
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains
    }),
    formatUrlString = _getFormatUrlMethods.formatUrlString,
    formatUrlInText = _getFormatUrlMethods.formatUrlInText;
  const _properties$modTitle = properties.modTitle,
    modTitle = _properties$modTitle === void 0 ? '' : _properties$modTitle,
    _properties$color = properties.color,
    color = _properties$color === void 0 ? '' : _properties$color,
    _properties$list = properties.list,
    list = _properties$list === void 0 ? [] : _properties$list,
    _properties$mergeComp = properties.mergeComponentStatus,
    mergeComponentStatus = _properties$mergeComp === void 0 ? false : _properties$mergeComp;
  // console.log('formatAreaCard list=', { list, domains });
  const configuration = list.map((item, index) => {
    return _objectSpread(_objectSpread({}, item), {}, {
      href: formatUrlString(item === null || item === void 0 ? void 0 : item.href),
      content: formatUrlInText(item === null || item === void 0 ? void 0 : item.content),
      key: `${index + 1}`,
      extendProps: {
        'report-event-goal': 'click_dl_doc'
      }
    });
  });
  return {
    modTitle,
    mergeComponentStatus,
    configuration,
    bgColor: color
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatAreaCard = formatAreaCard(data, {
        domains
      }),
      _formatAreaCard$modTi = _formatAreaCard.modTitle,
      modTitle = _formatAreaCard$modTi === void 0 ? '' : _formatAreaCard$modTi,
      _formatAreaCard$merge = _formatAreaCard.mergeComponentStatus,
      mergeComponentStatus = _formatAreaCard$merge === void 0 ? false : _formatAreaCard$merge,
      _formatAreaCard$confi = _formatAreaCard.configuration,
      configuration = _formatAreaCard$confi === void 0 ? [] : _formatAreaCard$confi,
      _formatAreaCard$bgCol = _formatAreaCard.bgColor,
      bgColor = _formatAreaCard$bgCol === void 0 ? '' : _formatAreaCard$bgCol;
    const bgStyle = bgColor ? (0, _componentUtils.doComponentsBgColorEvent)(bgColor) : {}; // 处理组件背景色
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: modTitle
    }, (0, _reportUtil.reportShow)(['show_areaCard', componentKey, modTitle])), /*#__PURE__*/React.createElement(ScenariosImageText, {
      configuration: configuration,
      mergeComponentStatus: mergeComponentStatus,
      flexTitle: modTitle,
      style: bgStyle,
      onTabClick: (tabIndex, cid) => {
        // 子组件点击跳转到tab定位
        window.childClickToTab(tabIndex, cid);
      }
    }));
  }
  return /*#__PURE__*/React.createElement("div", null);
}